import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import CardActionArea from '@mui/material/CardActionArea';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

const useStyle = makeStyles(() => ({
  label: {
    fontSize: 12,
  },
}));

const TilesLabel = ({ label, value, onClick }) => {
  const classes = useStyle();

  const renderContent = (
    <CardContent>
      <Typography color="primary" variant="body2" className={classes.label}>
        {label}
      </Typography>
      <Typography color="textPrimary" component="p">
        {value}
      </Typography>
    </CardContent>
  );

  return (
    <Card variant="elevation" elevation={0}>
      {onClick ? <CardActionArea onClick={onClick}>{renderContent}</CardActionArea> : renderContent}
    </Card>
  );
};

TilesLabel.defaultProps = {
  onClick: undefined,
};

TilesLabel.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClick: PropTypes.func,
};

export default TilesLabel;
